import React, { useRef } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Calendar } from "lucide-react";
import en from "date-fns/locale/en-GB";

function InputDatePicker({ date, onChange, minDate, minTime, label, error, touched, ...props }) {
  const hasError = error && touched;
  const datePickerRef = useRef(null);

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus();
    }
  };

  return (
    <div
      className={`relative w-full justify-between rounded-sm flex items-center bg-white border transition-all 
        ${hasError ? "border-red-500 focus-within:ring-red-500" : "border-slate-300 focus-within:ring-[#f5272b]"} 
        focus-within:ring-2`}
    >
      <ReactDatePicker
        ref={datePickerRef}
        selected={date}
        onChange={onChange}
        minDate={minDate}
        minTime={minTime}
        maxTime={new Date().setHours(23, 45, 0, 0)}
        showTimeSelect
        dateFormat="yyyy-MM-dd HH:mm"
        timeFormat="HH:mm"
        locale={en}
        timeIntervals={30}
        placeholderText={label || "Select date and time"}
        className="flex-1 px-5 py-4 text-base bg-transparent text-slate-700 md:text-lg focus:outline-none placeholder-slate-400"
        popperModifiers={[
          {
            name: "arrow",
            options: {
              padding: ({ popper, reference }) => ({
                right: Math.min(popper.width, reference.width) - 24,
              }),
            },
          },
        ]}
        {...props}
      />

      <button type="button" onClick={handleIconClick} className="pr-4 text-slate-400 hover:text-[#f5272b] transition">
        <Calendar size={22} />
      </button>

      {hasError && <p className="absolute left-0 mt-1 text-sm text-red-500 -bottom-5">{error}</p>}
    </div>
  );
}

export default InputDatePicker;
